module.exports = __webpack_public_path__ + "img/investment_3.60147831.jpg";